import React from 'react'
import { Typography, Box } from '@mui/material'
import FixedWidthContainer from 'components/FixedWidthContainer'
import DealerSignupSection from 'components/DealerSignupSection'
import ArrowListItem from 'pages/PrivacyPolicy/ArrowListItem'
import SectionHeader from 'components/SectionHeader'
import { useTranslation } from 'react-i18next'

const PrivacyPolicyPage = () => {
  const { t } = useTranslation()
  const handleEmailClick = () => {
    window.location.href = 'mailto:Info@musescabinets.com'
  }

  const handlePhoneClick = () => {
    window.location.href = 'tel:800-806-0708'
  }
  return (
    <Box>
      <FixedWidthContainer>
        <SectionHeader title={t('privacyPolicy.title')} />

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.intro')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.collectionTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.collectionIntro')}
          <Box sx={{ my: 2 }}>
            <ArrowListItem text={t('privacyPolicy.collectionItems.name')} />
            <ArrowListItem text={t('privacyPolicy.collectionItems.address')} />
            <ArrowListItem text={t('privacyPolicy.collectionItems.email')} />
            <ArrowListItem text={t('privacyPolicy.collectionItems.phone')} />
            <ArrowListItem text={t('privacyPolicy.collectionItems.jobTitle')} />
          </Box>
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.collectionBilling')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.collectionVoluntary')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.useTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.useDescription')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.sharingTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.sharingDescription1')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.sharingDescription2')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.trackingTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.trackingDescription')}
        </Typography>
        <Typography
          variant='h6'
          gutterBottom
          sx={{ mt: 4, fontWeight: 700, fontSize: '20px' }}
        >
          {t('privacyPolicy.autoCollectedTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.autoCollectedDescription')}
        </Typography>
        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.securityTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.securityDescription')}
        </Typography>

        <Box sx={{ my: 2 }}>
          <ArrowListItem text={t('privacyPolicy.sslProtocol')} />
        </Box>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.sslDescription')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.securityMeasures')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.deletionTitle')}
        </Typography>

        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.deletionIntro')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          <Box sx={{ my: 2 }}>
            <ArrowListItem
              text={t('privacyPolicy.deletionItems.deleteRecords')}
            />
            <ArrowListItem
              text={t('privacyPolicy.deletionItems.directProviders')}
            />
          </Box>
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.deletionExceptions')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.childrenTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.childrenDescription')}
        </Typography>

        <Typography
          variant='h6'
          gutterBottom
          sx={{ mt: 4, fontWeight: 700, fontSize: '20px' }}
        >
          {t('privacyPolicy.emailTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.emailDescription')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.changesTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.changesDescription')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.contactTitle')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.contactDescription')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.companyName')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.address1')}
        </Typography>
        <Typography variant='body1' sx={{ color: '#7C7C7C' }} gutterBottom>
          {t('privacyPolicy.address2')}
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.emailLabel')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ color: 'primary.main', cursor: 'pointer' }}
          gutterBottom
          onClick={handleEmailClick}
        >
          Info@musescabinets.com
        </Typography>

        <Typography variant='h3' gutterBottom sx={{ mt: 4 }}>
          {t('privacyPolicy.phoneLabel')}
        </Typography>
        <Typography
          variant='body1'
          sx={{ color: 'primary.main', cursor: 'pointer' }}
          gutterBottom
          onClick={handlePhoneClick}
        >
          800-806-0708
        </Typography>
        <Typography
          variant='body1'
          sx={{ my: 4, color: '#7C7C7C' }}
          gutterBottom
        >
          {t('privacyPolicy.effectiveDate')}
        </Typography>
      </FixedWidthContainer>
      <DealerSignupSection />
    </Box>
  )
}

export default PrivacyPolicyPage
